"use strict";

var _marked = [visitCallExpression, visitExpression, visitUnaryExpression, visitBinaryExpression, visitLogicalExpression, visitConditionalExpression, visitFunctionExpression, visitIfStatement, visitFunctionDeclaration, visitVariableDeclaration, visitReturnStatement, visitStatement, visitExpressionStatement, visitBlockStatement, visitProgram].map(regeneratorRuntime.mark);

Object.defineProperty(exports, "__esModule", { value: true });
var errorTypes_1 = require("./errorTypes");
function noop(parent, node) {
    return;
}
exports.noop = noop;
function visitCallExpression(node, visitors) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, exp;

    return regeneratorRuntime.wrap(function visitCallExpression$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 3;
                    _iterator = node.arguments[Symbol.iterator]();

                case 5:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _context.next = 11;
                        break;
                    }

                    exp = _step.value;
                    return _context.delegateYield(visitExpression(node, exp, visitors), "t0", 8);

                case 8:
                    _iteratorNormalCompletion = true;
                    _context.next = 5;
                    break;

                case 11:
                    _context.next = 17;
                    break;

                case 13:
                    _context.prev = 13;
                    _context.t1 = _context["catch"](3);
                    _didIteratorError = true;
                    _iteratorError = _context.t1;

                case 17:
                    _context.prev = 17;
                    _context.prev = 18;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }

                case 20:
                    _context.prev = 20;

                    if (!_didIteratorError) {
                        _context.next = 23;
                        break;
                    }

                    throw _iteratorError;

                case 23:
                    return _context.finish(20);

                case 24:
                    return _context.finish(17);

                case 25:
                    return _context.delegateYield(visitExpression(node, node.callee, visitors), "t2", 26);

                case 26:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked[0], this, [[3, 13, 17, 25], [18,, 20, 24]]);
}
function visitExpression(parent, node, visitors) {
    return regeneratorRuntime.wrap(function visitExpression$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.t0 = node.type;
                    _context2.next = _context2.t0 === 'CallExpression' ? 3 : _context2.t0 === 'UnaryExpression' ? 9 : _context2.t0 === 'BinaryExpression' ? 13 : _context2.t0 === 'LogicalExpression' ? 19 : _context2.t0 === 'ConditionalExpression' ? 25 : _context2.t0 === 'FunctionExpression' ? 31 : _context2.t0 === 'Identifier' ? 37 : _context2.t0 === 'Literal' ? 42 : 47;
                    break;

                case 3:
                    _context2.next = 5;
                    return visitors.CallExpression.before(parent, node);

                case 5:
                    return _context2.delegateYield(visitCallExpression(node, visitors), "t1", 6);

                case 6:
                    _context2.next = 8;
                    return visitors.CallExpression.after(parent, node);

                case 8:
                    return _context2.abrupt("break", 49);

                case 9:
                    return _context2.delegateYield(visitUnaryExpression(node, visitors), "t2", 10);

                case 10:
                    _context2.next = 12;
                    return visitors.UnaryExpression.after(parent, node);

                case 12:
                    return _context2.abrupt("break", 49);

                case 13:
                    _context2.next = 15;
                    return visitors.BinaryExpression.before(parent, node);

                case 15:
                    return _context2.delegateYield(visitBinaryExpression(node, visitors), "t3", 16);

                case 16:
                    _context2.next = 18;
                    return visitors.BinaryExpression.after(parent, node);

                case 18:
                    return _context2.abrupt("break", 49);

                case 19:
                    _context2.next = 21;
                    return visitors.LogicalExpression.before(parent, node);

                case 21:
                    return _context2.delegateYield(visitLogicalExpression(node, visitors), "t4", 22);

                case 22:
                    _context2.next = 24;
                    return visitors.LogicalExpression.after(parent, node);

                case 24:
                    return _context2.abrupt("break", 49);

                case 25:
                    _context2.next = 27;
                    return visitors.ConditionalExpression.before(parent, node);

                case 27:
                    return _context2.delegateYield(visitConditionalExpression(node, visitors), "t5", 28);

                case 28:
                    _context2.next = 30;
                    return visitors.ConditionalExpression.after(parent, node);

                case 30:
                    return _context2.abrupt("break", 49);

                case 31:
                    _context2.next = 33;
                    return visitors.FunctionExpression.before(parent, node);

                case 33:
                    return _context2.delegateYield(visitFunctionExpression(node, visitors), "t6", 34);

                case 34:
                    _context2.next = 36;
                    return visitors.FunctionExpression.after(parent, node);

                case 36:
                    return _context2.abrupt("break", 49);

                case 37:
                    _context2.next = 39;
                    return visitors.Identifier.before(parent, node);

                case 39:
                    _context2.next = 41;
                    return visitors.Identifier.after(parent, node);

                case 41:
                    return _context2.abrupt("break", 49);

                case 42:
                    _context2.next = 44;
                    return visitors.Literal.before(parent, node);

                case 44:
                    _context2.next = 46;
                    return visitors.Literal.after(parent, node);

                case 46:
                    return _context2.abrupt("break", 49);

                case 47:
                    _context2.next = 49;
                    return visitors.onError(errorTypes_1.ErrorType.MatchFailure, parent, node);

                case 49:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked[1], this);
}
function visitUnaryExpression(node, visitors) {
    return regeneratorRuntime.wrap(function visitUnaryExpression$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    return _context3.delegateYield(visitExpression(node, node.argument, visitors), "t0", 1);

                case 1:
                case "end":
                    return _context3.stop();
            }
        }
    }, _marked[2], this);
}
function visitBinaryExpression(node, visitors) {
    return regeneratorRuntime.wrap(function visitBinaryExpression$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    return _context4.delegateYield(visitExpression(node, node.left, visitors), "t0", 1);

                case 1:
                    return _context4.delegateYield(visitExpression(node, node.right, visitors), "t1", 2);

                case 2:
                case "end":
                    return _context4.stop();
            }
        }
    }, _marked[3], this);
}
function visitLogicalExpression(node, visitors) {
    return regeneratorRuntime.wrap(function visitLogicalExpression$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    return _context5.delegateYield(visitExpression(node, node.left, visitors), "t0", 1);

                case 1:
                    return _context5.delegateYield(visitExpression(node, node.right, visitors), "t1", 2);

                case 2:
                case "end":
                    return _context5.stop();
            }
        }
    }, _marked[4], this);
}
function visitConditionalExpression(node, visitors) {
    return regeneratorRuntime.wrap(function visitConditionalExpression$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    return _context6.delegateYield(visitExpression(node, node.test, visitors), "t0", 1);

                case 1:
                    return _context6.delegateYield(visitExpression(node, node.consequent, visitors), "t1", 2);

                case 2:
                    return _context6.delegateYield(visitExpression(node, node.alternate, visitors), "t2", 3);

                case 3:
                case "end":
                    return _context6.stop();
            }
        }
    }, _marked[5], this);
}
function visitFunctionExpression(node, visitors) {
    return regeneratorRuntime.wrap(function visitFunctionExpression$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    if (visitors.skip) {
                        _context7.next = 2;
                        break;
                    }

                    return _context7.delegateYield(visitBlockStatement(node, node.body, visitors), "t0", 2);

                case 2:
                case "end":
                    return _context7.stop();
            }
        }
    }, _marked[6], this);
}
function visitIfStatement(node, visitors) {
    return regeneratorRuntime.wrap(function visitIfStatement$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    return _context8.delegateYield(visitExpression(node, node.test, visitors), "t0", 1);

                case 1:
                    if (!node.consequent) {
                        _context8.next = 7;
                        break;
                    }

                    if (!(node.consequent.type === 'BlockStatement')) {
                        _context8.next = 6;
                        break;
                    }

                    return _context8.delegateYield(visitBlockStatement(node, node.consequent, visitors), "t1", 4);

                case 4:
                    _context8.next = 7;
                    break;

                case 6:
                    return _context8.delegateYield(visitStatement(node, node.consequent, visitors), "t2", 7);

                case 7:
                    if (!node.alternate) {
                        _context8.next = 13;
                        break;
                    }

                    if (!(node.alternate.type === 'BlockStatement')) {
                        _context8.next = 12;
                        break;
                    }

                    return _context8.delegateYield(visitBlockStatement(node, node.alternate, visitors), "t3", 10);

                case 10:
                    _context8.next = 13;
                    break;

                case 12:
                    return _context8.delegateYield(visitStatement(node, node.alternate, visitors), "t4", 13);

                case 13:
                case "end":
                    return _context8.stop();
            }
        }
    }, _marked[7], this);
}
function visitFunctionDeclaration(node, visitors) {
    return regeneratorRuntime.wrap(function visitFunctionDeclaration$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    return _context9.delegateYield(visitBlockStatement(node, node.body, visitors), "t0", 1);

                case 1:
                case "end":
                    return _context9.stop();
            }
        }
    }, _marked[8], this);
}
function visitVariableDeclaration(node, visitors) {
    var declarator;
    return regeneratorRuntime.wrap(function visitVariableDeclaration$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    if (!(node.declarations.length === 1)) {
                        _context10.next = 10;
                        break;
                    }

                    declarator = node.declarations[0];

                    if (!(declarator.id.type !== 'Identifier')) {
                        _context10.next = 7;
                        break;
                    }

                    _context10.next = 5;
                    return visitors.onError(errorTypes_1.ErrorType.DeclaratorNotIdentifier, node, declarator);

                case 5:
                    _context10.next = 8;
                    break;

                case 7:
                    return _context10.delegateYield(visitExpression(node, declarator.init, visitors), "t0", 8);

                case 8:
                    _context10.next = 12;
                    break;

                case 10:
                    _context10.next = 12;
                    return visitors.onError(errorTypes_1.ErrorType.DeclaratorNotIdentifier, node, null);

                case 12:
                case "end":
                    return _context10.stop();
            }
        }
    }, _marked[9], this);
}
function visitReturnStatement(node, visitors) {
    return regeneratorRuntime.wrap(function visitReturnStatement$(_context11) {
        while (1) {
            switch (_context11.prev = _context11.next) {
                case 0:
                    return _context11.delegateYield(visitExpression(node, node.argument, visitors), "t0", 1);

                case 1:
                case "end":
                    return _context11.stop();
            }
        }
    }, _marked[10], this);
}
function visitStatement(parent, node, visitors) {
    return regeneratorRuntime.wrap(function visitStatement$(_context12) {
        while (1) {
            switch (_context12.prev = _context12.next) {
                case 0:
                    _context12.t0 = node.type;
                    _context12.next = _context12.t0 === 'ExpressionStatement' ? 3 : _context12.t0 === 'IfStatement' ? 9 : _context12.t0 === 'FunctionDeclaration' ? 15 : _context12.t0 === 'VariableDeclaration' ? 21 : _context12.t0 === 'ReturnStatement' ? 27 : 33;
                    break;

                case 3:
                    _context12.next = 5;
                    return visitors.ExpressionStatement.before(parent, node);

                case 5:
                    return _context12.delegateYield(visitExpressionStatement(node, visitors), "t1", 6);

                case 6:
                    _context12.next = 8;
                    return visitors.ExpressionStatement.after(parent, node);

                case 8:
                    return _context12.abrupt("break", 36);

                case 9:
                    _context12.next = 11;
                    return visitors.IfStatement.before(parent, node);

                case 11:
                    return _context12.delegateYield(visitIfStatement(node, visitors), "t2", 12);

                case 12:
                    _context12.next = 14;
                    return visitors.IfStatement.after(parent, node);

                case 14:
                    return _context12.abrupt("break", 36);

                case 15:
                    _context12.next = 17;
                    return visitors.FunctionDeclaration.before(parent, node);

                case 17:
                    return _context12.delegateYield(visitFunctionDeclaration(node, visitors), "t3", 18);

                case 18:
                    _context12.next = 20;
                    return visitors.FunctionDeclaration.after(parent, node);

                case 20:
                    return _context12.abrupt("break", 36);

                case 21:
                    _context12.next = 23;
                    return visitors.VariableDeclaration.before(parent, node);

                case 23:
                    return _context12.delegateYield(visitVariableDeclaration(node, visitors), "t4", 24);

                case 24:
                    _context12.next = 26;
                    return visitors.VariableDeclaration.after(parent, node);

                case 26:
                    return _context12.abrupt("break", 36);

                case 27:
                    _context12.next = 29;
                    return visitors.ReturnStatement.before(parent, node);

                case 29:
                    return _context12.delegateYield(visitReturnStatement(node, visitors), "t5", 30);

                case 30:
                    _context12.next = 32;
                    return visitors.ReturnStatement.after(parent, node);

                case 32:
                    return _context12.abrupt("break", 36);

                case 33:
                    _context12.next = 35;
                    return visitors.onError(errorTypes_1.ErrorType.MatchFailure, parent, node);

                case 35:
                    return _context12.abrupt("break", 36);

                case 36:
                case "end":
                    return _context12.stop();
            }
        }
    }, _marked[11], this);
}
function visitExpressionStatement(node, visitors) {
    return regeneratorRuntime.wrap(function visitExpressionStatement$(_context13) {
        while (1) {
            switch (_context13.prev = _context13.next) {
                case 0:
                    return _context13.delegateYield(visitExpression(node, node.expression, visitors), "t0", 1);

                case 1:
                case "end":
                    return _context13.stop();
            }
        }
    }, _marked[12], this);
}
function visitBlockStatement(parent, node, visitors) {
    var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, stmt;

    return regeneratorRuntime.wrap(function visitBlockStatement$(_context14) {
        while (1) {
            switch (_context14.prev = _context14.next) {
                case 0:
                    _iteratorNormalCompletion2 = true;
                    _didIteratorError2 = false;
                    _iteratorError2 = undefined;
                    _context14.prev = 3;
                    _iterator2 = node.body[Symbol.iterator]();

                case 5:
                    if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                        _context14.next = 11;
                        break;
                    }

                    stmt = _step2.value;
                    return _context14.delegateYield(visitStatement(parent, stmt, visitors), "t0", 8);

                case 8:
                    _iteratorNormalCompletion2 = true;
                    _context14.next = 5;
                    break;

                case 11:
                    _context14.next = 17;
                    break;

                case 13:
                    _context14.prev = 13;
                    _context14.t1 = _context14["catch"](3);
                    _didIteratorError2 = true;
                    _iteratorError2 = _context14.t1;

                case 17:
                    _context14.prev = 17;
                    _context14.prev = 18;

                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }

                case 20:
                    _context14.prev = 20;

                    if (!_didIteratorError2) {
                        _context14.next = 23;
                        break;
                    }

                    throw _iteratorError2;

                case 23:
                    return _context14.finish(20);

                case 24:
                    return _context14.finish(17);

                case 25:
                case "end":
                    return _context14.stop();
            }
        }
    }, _marked[13], this, [[3, 13, 17, 25], [18,, 20, 24]]);
}
function visitProgram(node, visitors) {
    var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, stmt;

    return regeneratorRuntime.wrap(function visitProgram$(_context15) {
        while (1) {
            switch (_context15.prev = _context15.next) {
                case 0:
                    _context15.next = 2;
                    return visitors.Program.before(undefined, node);

                case 2:
                    _iteratorNormalCompletion3 = true;
                    _didIteratorError3 = false;
                    _iteratorError3 = undefined;
                    _context15.prev = 5;
                    _iterator3 = node.body[Symbol.iterator]();

                case 7:
                    if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                        _context15.next = 13;
                        break;
                    }

                    stmt = _step3.value;
                    return _context15.delegateYield(visitStatement(node, stmt, visitors), "t0", 10);

                case 10:
                    _iteratorNormalCompletion3 = true;
                    _context15.next = 7;
                    break;

                case 13:
                    _context15.next = 19;
                    break;

                case 15:
                    _context15.prev = 15;
                    _context15.t1 = _context15["catch"](5);
                    _didIteratorError3 = true;
                    _iteratorError3 = _context15.t1;

                case 19:
                    _context15.prev = 19;
                    _context15.prev = 20;

                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }

                case 22:
                    _context15.prev = 22;

                    if (!_didIteratorError3) {
                        _context15.next = 25;
                        break;
                    }

                    throw _iteratorError3;

                case 25:
                    return _context15.finish(22);

                case 26:
                    return _context15.finish(19);

                case 27:
                    _context15.next = 29;
                    return visitors.Program.after(undefined, node);

                case 29:
                case "end":
                    return _context15.stop();
            }
        }
    }, _marked[14], this, [[5, 15, 19, 27], [20,, 22, 26]]);
}
exports.visitProgram = visitProgram;
//# sourceMappingURL=visitors.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/visitors.js
// module id = 182
// module chunks = 3